import React , {Component} from "react";
import {connect} from "react-redux";
import {change , formValueSelector } from "redux-form";
import { transformVehicle } from "../util/Validators";

function ModelList(props){

    const {brandConfig, brand} = props;

    const  LookupModelAsset = (name) => {
        return brandConfig !== undefined && brandConfig[name] ? `${brandConfig[name].url}` : `https://assets.fcaab.com.au/assets-public/vpc/images/jeep/1717/261.jpg`;
    };

    const checkName = (i) => {
        let vehicleName = brandConfig[transformVehicle(i)].displayname
        if(vehicleName == "Grand Cherokee"){
            vehicleName = "Grand Cherokee – 5 seat"
        }
        if(vehicleName == "Grand Cherokee L"){
            vehicleName = "Grand Cherokee – 7 seat"
        }
        if(vehicleName == "Fiat 500E"){
            vehicleName = "Fiat 500e"
        }
        if(vehicleName == "Abarth 500E"){
            vehicleName = "Abarth 500e"
        }
        if(vehicleName == "Tonale PHEV"){
            vehicleName = "Tonale Plug-In Hybrid"
        }
        if(vehicleName == "Wrangler JL"){
            vehicleName = "Wrangler"
        }
        if(vehicleName == "C10"){
            vehicleName = "C10 BEV"
        }
        if(vehicleName == "C10 Reev"){
            vehicleName = "C10 REEV Ultra Hybrid"
        }
        return vehicleName;
    };

    class List extends Component {

        handleClick = (model_configuration_id) => {
          let vehicle = this.props.vehicle || "";
          if(vehicle && vehicle.toLowerCase().trim() === model_configuration_id.toLowerCase().trim() ){
              vehicle = "";
          }
          else{
              vehicle = model_configuration_id.trim() ;

          }
          this.props.dispatch(change(props.formName , 'vehicle' , vehicle.trim()));
          this.props.dispatch(change(props.formName , 'formState.selectModel' , vehicle.trim().length > 0 ));

            this.props.handleClick();

        };

        selected = (model_configuration_id) => {
            const vehicle = this.props.vehicle || "";
            return vehicle.toLowerCase().trim() === model_configuration_id.toLowerCase().trim() ? "selected" : "";
        };

        componentDidMount() {
            const filteredItems = this.props.items.filter(i =>
                brand === "" || checkName(i).toLowerCase().includes(brand.toLowerCase())
            );
            const number_of_models = filteredItems.length;
            if (number_of_models === 1 && this.props.vehicle !== filteredItems[0]) {
                this.props.dispatch(change(this.props.formName, 'vehicle', filteredItems[0]));
                this.props.dispatch(change(this.props.formName, 'formState.selectModel', true));
                this.props.handleClick();
            }
        }

        render(){

            return this.props.items.map((i, k) => {
                if (brand === "" || checkName(i).toLowerCase().includes(brand.toLowerCase())) {
                    return (
                        <div className={"col-6 col-md-4 col-lg-3 d-flex " + transformVehicle(i).toLowerCase()} key={k}>
                            <div className={"card flex-fill border-0 mb-3 text-center " + this.selected(i)} onClick={(e) => {
                                this.handleClick(i)
                            }}>
                                <div className="card-body">
                                    <picture>
                                        <img className={' border-0 img-fluid model-image'} src={LookupModelAsset(transformVehicle(i))} alt={`${brandConfig[transformVehicle(i)].displayname}`} />
                                    </picture>
                                    <p className="card-text">{checkName(i)}</p>
                                </div>
                            </div>
                        </div>
                    );
                } else {
                    return null;
                }
            });
            
        }
    }

    const NewList = connect(state  => {
        const selector = formValueSelector(props.formName);
        return {
            vehicle : selector(state, 'vehicle')
        };
    })(List);

    return (<NewList {...props}/>)

}



export default ModelList;

